import { getComputerAssetQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/computerKeys.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { assetsClient } from '#pplx_generated/typespec/rest/assets/client.js';
export class AccessDeniedError extends Error {
    constructor() {
        super('Access denied');
        this.name = 'AccessDeniedError';
    }
}
export async function fetchAssetData({ queryKey, }) {
    const [, slugOrId, view, collectionUuid] = QueryClientHelper.unmakeQueryKey(queryKey);
    if (!slugOrId)
        throw new Error('Asset not found');
    const { data, error, response } = await assetsClient.GET('/rest/assets/{asset_id}/data', 'computer-asset-data', {
        params: {
            path: { asset_id: slugOrId },
            query: {
                source: 'page',
                ...(view ? { view } : undefined),
                ...(collectionUuid ? { collection_uuid: collectionUuid } : undefined),
            },
        },
    });
    if (response.status === 403)
        throw new AccessDeniedError();
    if (error || !data)
        throw new Error('Asset not found');
    return data;
}
//# sourceMappingURL=computerAssetData.js.map